var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('Chart',{ref:"chart",staticClass:"diagram p-0 m-0 w-100 h-100",style:({cursor: _vm.cursor}),attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }